import * as React from 'react';
import { Auth0MockContainer } from '../../organisms/Auth0MockContainer';
import { Trans } from '@lingui/react';
import ForgotUsernamePasswordForm from '../../organisms/ForgotUsernamePasswordForm/ForgotUsernamePasswordForm';

const ForgotUsernamePasswordSelect: React.FC = () => {
  return (
    <Auth0MockContainer
      title={<Trans id="Select" />}
      renderBackLink={
        <a href="/api/onboard/back-to-login">
          <Trans id="Back to Login" />
        </a>
      }
    >
      <ForgotUsernamePasswordForm />
    </Auth0MockContainer>
  );
};

export default ForgotUsernamePasswordSelect;
